import { gql } from '@apollo/client';

export const PATCH_LOCALIZATION_MUTATION = gql`
    mutation patchResourceLocalization($input: PatchResourceLocalizationInput!) {
        result: patchResourceLocalization(input: $input) {
            id 
            
        }
    }
`;